import apiClient from "./client.jsx";
import { encryptPinCode } from "../utils/cryptoUtils.js";

// TV 관련 API
export const tvApi = {
  // TV 목록 조회
  getTvList: async () => {
    const response = await apiClient.get("/api/tvs");
    return response.data;
  },

  // TV 상세 조회
  getTv: async (tvId) => {
    const response = await apiClient.get(`/api/tvs/${tvId}`);
    return response.data;
  },

  getTvStatus: async (tvId) => {
    const response = await apiClient.get(`/api/tvs/${tvId}/status`);
    return response.data;
  },

  // TV name으로 상태 조회
  getTvStatusByName: async (tvName) => {
    const response = await apiClient.get(`/api/tvs/play/${tvName}/status`);
    return response.data;
  },

  getTvPlay: async (tvName) => {
    const response = await apiClient.get(`/api/tvs/play/${tvName}`);
    return response.data;
  },
  // TV 생성
  createTv: async (tvData) => {
    const response = await apiClient.post("/api/tvs", tvData);
    return response.data;
  },

  // 🎯 TV 수정 - 백엔드 TvUpdateRequest 스펙에 맞게 수정
  updateTv: async (tvId, tvData) => {
    try {
      // console.log(`TV ${tvId} 업데이트 요청 데이터:`, tvData);

      // 백엔드 POST /{tvId} 엔드포인트 사용
      const response = await apiClient.post(`/api/tvs/${tvId}`, tvData);

      // console.log(`TV ${tvId} 업데이트 응답:`, response.data);
      return response.data;
    } catch (error) {
      // console.error(`TV ${tvId} 업데이트 실패:`, error);

      // 에러 응답에서 메시지 추출
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "TV 업데이트에 실패했습니다.";

      throw new Error(errorMessage);
    }
  },

  // TV 활성화/비활성화
  updateTvEnable: async (tvId, enabled) => {
    const response = await apiClient.put(`/api/tvs/${tvId}`, null, {
      params: { enabled },
    });
    return response.data;
  },

  // TV 다중 삭제
  deleteTvMulti: async (tvIds) => {
    const response = await apiClient.put("/api/tvs/multi", tvIds);
    return response.data;
  },

  // TV 인증번호 여부 조회
  getTvAuthentication: async (tvId) => {
    const response = await apiClient.get(`/api/tvs/${tvId}/authentication`);
    return response.data;
  },

  // TV 인증 세션 시작 (RSA 키쌍 생성 및 공개키 반환)
  startTvAuth: async (tvId) => {
    const response = await apiClient.post(`/api/tvs/${tvId}/auth/start`);
    return response.data;
  },

  // TV 인증번호 인증 (RSA 암호화된 인증번호 전송)
  authenticateTv: async (tvId, encryptedAuthCode, keyId) => {
    try {
      // console.log(`TV ${tvId} 인증 요청 - keyId: ${keyId}`);

      // 백엔드 TvAuthRequest 스펙에 맞는 데이터 전송
      const requestData = {
        encryptedAuthCode, // RSA로 암호화된 인증번호
        keyId, // Redis에서 개인키를 찾기 위한 ID
      };

      const response = await apiClient.post(
        `/api/tvs/${tvId}/auth`,
        requestData
      );
      return response.data;
    } catch (error) {
      // console.error("TV 인증 API 호출 실패:", error);
      throw error;
    }
  },

  // TV 설정 조회 (백엔드에 해당 API가 있다면)
  getTVSettings: async (tvId) => {
    try {
      const response = await apiClient.get(`/api/tvs/${tvId}/settings`);
      return response.data;
    } catch (error) {
      // 설정 API가 없다면 기본값 반환
      // console.warn("TV 설정 API가 구현되지 않았습니다:", error);
      return {
        success: true,
        data: {
          generalSettings: {
            transitionDuration: 1,
            transitionStyle: "fade",
          },
          pinSettings: {
            enabled: false,
            code: "",
          },
        },
      };
    }
  },

  // TV 설정 수정 (백엔드에 해당 API가 있다면)
  updateTVSettings: async (tvId, settings) => {
    try {
      const response = await apiClient.put(
        `/api/tvs/${tvId}/settings`,
        settings
      );
      return response.data;
    } catch (error) {
      // console.warn("TV 설정 수정 API가 구현되지 않았습니다:", error);
      return {
        success: true,
        data: settings,
      };
    }
  },
};
